/* rtf-size-search.js
   Upgrades the size variant <select> into a searchable combobox when it has
   many options. The theme also runs a "nice-select" plugin on the same
   <select>; we suppress that plugin's dropdown and own the control, but the
   native <select> stays the form's source of truth — we set its value and
   dispatch 'change' so the theme's variant logic (price, stock, images) runs.
   Progressive enhancement; the native select still works if JS fails. */
(function () {
  var THRESHOLD = 8; // only enhance dropdowns with more sizes than this

  function killNice(host) {
    // remove the theme plugin's generated dropdown so it doesn't double up
    host.querySelectorAll('.nice-select').forEach(function (n) { n.remove(); });
  }

  function enhance(sel) {
    var host = sel.closest('.select') || sel.parentNode;
    if (!host) return;
    if (sel.__rtfSize) return;
    if (sel.options.length <= THRESHOLD) return;
    // Only remove the theme's nice-select dropdown once we're committed to replacing it.
    // Killing it before the threshold check stripped the styled dropdown from low-option
    // products (e.g. Filtrete, 4 sizes) and left a broken/blank/cramped native <select>.
    killNice(host);
    sel.__rtfSize = true;

    var opts = Array.prototype.slice.call(sel.options);

    var box = document.createElement('div');
    box.className = 'rtf-ss';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'rtf-ss__toggle';
    toggle.setAttribute('aria-haspopup', 'listbox');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span class="rtf-ss__val"></span><svg class="rtf-ss__caret" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

    var panel = document.createElement('div');
    panel.className = 'rtf-ss__panel';
    panel.hidden = true;

    var search = document.createElement('input');
    search.type = 'text';
    search.className = 'rtf-ss__search';
    search.setAttribute('placeholder', 'Search sizes…');
    search.setAttribute('aria-label', 'Search sizes');

    var list = document.createElement('div');
    list.className = 'rtf-ss__list';
    list.setAttribute('role', 'listbox');

    panel.appendChild(search);
    panel.appendChild(list);
    box.appendChild(toggle);
    box.appendChild(panel);

    function currentText() {
      var o = sel.options[sel.selectedIndex];
      return o ? o.textContent.trim() : 'Select size';
    }
    function syncVal() { box.querySelector('.rtf-ss__val').textContent = currentText(); }

    // normalize so `16"x25"x1"` matches a typed `16x25` / `16 x 25` / `16x25x1`
    function norm(s) { return (s || '').toLowerCase().replace(/[\s"″'']/g, ''); }

    function draw(filter) {
      list.innerHTML = '';
      var f = norm(filter);
      var shown = 0;
      opts.forEach(function (o) {
        var t = o.textContent.trim();
        if (o.value === '' && o.disabled) return;
        if (f && norm(t).indexOf(f) < 0) return;
        shown++;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'rtf-ss__item';
        item.setAttribute('role', 'option');
        if (o.disabled) item.classList.add('is-oos');
        if (o.selected) item.setAttribute('aria-selected', 'true');
        item.textContent = t + (o.disabled ? ' — out of stock' : '');
        item.addEventListener('click', function () {
          if (o.disabled) return;
          sel.value = o.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          syncVal();
          close();
          toggle.focus();
        });
        list.appendChild(item);
      });
      if (!shown) {
        var none = document.createElement('div');
        none.className = 'rtf-ss__none';
        none.textContent = 'No sizes match “' + filter + '”';
        list.appendChild(none);
      }
    }

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      search.value = '';
      draw('');
      search.focus();
    }
    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () { panel.hidden ? open() : close(); });
    search.addEventListener('input', function () { draw(search.value); });
    search.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); toggle.focus(); } });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    sel.addEventListener('change', syncVal);

    host.classList.add('rtf-ss-host');
    host.appendChild(box);
    syncVal();
  }

  function tidy() {
    // Remove the "About the filter image" note (its message is now a caption on the
    // image). It shares a panel with the delivery card, so we must hide only the
    // about-image card itself — pick the LARGEST element that contains the
    // about-image text but NOT the delivery card (= the card, not the panel).
    //
    // The delivery card renders in one of two forms: the computed estimator
    // ("Estimated delivery: ...") or the custom.delivery override from
    // rtf-delivery-note.liquid, which carries arbitrary merchant text and is
    // marked with [data-rtf-delivery]. BOTH must be excluded — matching only on
    // the "Estimated delivery" string silently hid the whole panel (and the
    // override with it) on every product using the metafield.
    var about = [].slice.call(document.querySelectorAll('.product__info-container *, .product__media-wrapper *')).filter(function (e) {
      var t = e.textContent || '';
      if (e.querySelector && e.querySelector('[data-rtf-delivery]')) return false;
      return /About the filter image/i.test(t) && !/Estimated delivery/i.test(t);
    });
    if (about.length) {
      about.sort(function (a, b) { return a.textContent.length - b.textContent.length; });
      var card = about[about.length - 1];
      if (!card.__rtfTidied) { card.__rtfTidied = true; card.style.display = 'none'; }
    }
    // Hide the below-media wrapper if it's left empty after removing description/specs/table.
    // NOTE: only target this static wrapper — info-column panels (e.g. the lead-time
    // "Estimated delivery" card) are populated by JS AFTER load and must not be hidden.
    document.querySelectorAll('.product__media-submedia-wrapper').forEach(function (el) {
      if (el.__rtfEmpty) return;
      var hasText = (el.textContent || '').replace(/\s+/g, '').length > 2;
      var hasMedia = el.querySelector('img, svg, input, button, select, video, iframe');
      if (!hasText && !hasMedia) { el.__rtfEmpty = true; el.style.display = 'none'; }
    });
  }

  function init() {
    document.querySelectorAll('.product-form__input--dropdown select').forEach(enhance);
    tidy();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // run again after the theme's nice-select plugin has initialized, so we win
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
